import type { ButtonProps, PropsWithRefObject, TooltipProps } from '@kc-console/common-ui';

const INITIAL_TOOLTIP_BUTTON_TIMEOUT = 1000;

type TooltipButtonProps<TButtonProps = ButtonProps> = TButtonProps &
  Pick<TooltipProps, 'message' | 'placement'> &
  PropsWithRefObject<HTMLButtonElement> & {
    /**
     * 버튼을 클릭한 경우에만 툴팁이 표시됩니다.
     * @default false
     */
    click?: boolean;
    /**
     * 버튼이 부모 요소의 전체 너비를 차지합니다.
     * @default false
     */
    fullWidth?: boolean;
    /**
     * click = true일 때, 툴팁이 표시되는 시간입니다.
     * @default 1000
     */
    timeout?: number;
    /**
     * message, placement를 제외한 tooltip의 props를 설정 할 수 있습니다.
     */
    tooltipProps?: Omit<TooltipProps, 'children' | 'message' | 'placement'>;
  };

export { INITIAL_TOOLTIP_BUTTON_TIMEOUT };
export type { TooltipButtonProps };
